import { LoadingPlaceholder } from '@components-deprecated'

import { Color, Icon, Link } from '@billy/design-system'
import { css } from '@emotion/core'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { QueryParamKeys } from '../../../enums/queryParamKeys'
import { useQueryParamsStorage } from '../../../hooks/useQueryParamsStorage'
import { SpecificState } from '../../../types/reduxSaga-deprecated'
import { reactClass } from '../../../utils'
import { filtersChanged } from '../action-creators'
import { BankReconcileQueryParams, BankReconcileSortProps } from '../types'
import { DroppableTransactions } from './DroppableTransactions'
import * as Styled from './styles'

export const TransactionList = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { setQueryParams } = useQueryParamsStorage<BankReconcileQueryParams>(QueryParamKeys.TransactionList)

  const isBalanceBarOpen = useSelector((state: SpecificState) => state.bankReconciliation.isBalanceBarOpen)
  const billyTransactions = useSelector((state: SpecificState) => state.bankReconciliation.billyTransactions)
  const transactionsLoading = useSelector((state: SpecificState) => state.bankReconciliation.transactionsLoading)
  const transactionsSortProperty = useSelector(
    (state: SpecificState) => state.bankReconciliation.filters.transactionsSortProperty,
  )
  const transactionsSortDirection = useSelector(
    (state: SpecificState) => state.bankReconciliation.filters.transactionsSortDirection,
  )

  const handleSort = useCallback(
    (title: BankReconcileSortProps) => {
      const direction = transactionsSortProperty === title ? transactionsSortDirection * -1 : 1

      setQueryParams({ transactionsSortProperty: title, transactionsSortDirection: String(direction) }, '', false)

      dispatch(
        filtersChanged({
          transactionsSortProperty: title,
          transactionsSortDirection: direction,
        }),
      )
    },
    [dispatch, setQueryParams, transactionsSortProperty, transactionsSortDirection],
  )

  return (
    <div className={reactClass('transaction-list-container')}>
      <Styled.TableHeaderWrapper className={reactClass('list-heading')}>
        <Link onClick={() => handleSort('entryDate')} underlined={false}>
          {t('bankreconciliation.matchgroups.billdate')}
          {transactionsSortProperty === 'entryDate' &&
            (transactionsSortDirection === -1 ? (
              <Icon icon="chevronUp" color={Color.Lavender500} />
            ) : (
              <Icon icon="chevronDown" color={Color.Lavender500} />
            ))}
        </Link>
        <Link
          disabled
          css={css`
            flex: 1;
          `}
        >
          {t('bankreconciliation.matchgroups.description')}
        </Link>

        <Link onClick={() => handleSort('sideAmount')} underlined={false}>
          {t('bankreconciliation.matchgroups.amount')}
          {transactionsSortProperty === 'sideAmount' &&
            (transactionsSortDirection === -1 ? (
              <Icon icon="chevronUp" color={Color.Lavender500} />
            ) : (
              <Icon icon="chevronDown" color={Color.Lavender500} />
            ))}
        </Link>
      </Styled.TableHeaderWrapper>
      <Styled.ScrollableList className={reactClass('list-scrollable')} isBalanceBarOpen={isBalanceBarOpen}>
        {transactionsLoading ? (
          <LoadingPlaceholder />
        ) : (
          <DroppableTransactions
            collection={billyTransactions}
            id="billytransaction:source"
            type="billytransaction"
            highlightOnDraggingOver
          />
        )}
      </Styled.ScrollableList>
    </div>
  )
}
